import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { TableDatasource } from '@gamelearn/skeletor/models';
import { MarsGroup } from 'app/mars/models/MarsGroup';
import { MarsGroupActivityListService } from './mars-group-activity-list.service';
import { StoreService } from 'core/services/store.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-mars-group-activity',
  templateUrl: './mars-group-activity.component.html',
  styleUrls: ['./mars-group-activity.component.scss'],
  providers: [MarsGroupActivityListService]
})
export class MarsGroupActivityComponent implements OnInit, OnChanges {
  @Input() group: MarsGroup;
  public listId = 'MARS_GROUP_ACTIVITY_LIST';
  public dataSource: TableDatasource;
  public toolbarConfig: any = {
    list: {
      listId: this.listId,
      download: true,
      filterRow: true,
      columnChooser: false,
      skeletor: true
    }
  };
  public rangeConfig: any;

  constructor(private activityListService: MarsGroupActivityListService, private translate: TranslateService) {}

  ngOnInit(): void {}

  ngOnChanges(): void {
    this.getDataSource();
    this.setRangeConfig();
  }

  async getDataSource() {
    const { session, turn } = this.getSessionFromAbsoluteTurn(this.getCurrentSessionIndex() * this.group.maxTurns);
    const options = {
      filters: {
        groupId: this.group.id,
        session,
        turn
      }
    };
    this.dataSource = await this.activityListService.getDatasource(this.listId, options);
  }

  setRangeConfig() {
    const maxSessions = this.group.sessions.length;
    const maxTurns = this.group.maxTurns;
    const totalTurns = maxSessions * maxTurns;
    const startLabel = this.translate.instant('reports.columns.start_date');
    const sessionLabel = this.translate.instant('mars.session');
    const turnLabel = this.translate.instant('reports.turn');
    const currentSessionIndex = this.getCurrentSessionIndex();

    this.rangeConfig = {
      keyboard: true,
      grid: false,
      min: 0,
      max: totalTurns,
      from: currentSessionIndex * maxTurns,
      prettify: (absoluteTurnNumber) => {
        if (absoluteTurnNumber > 0) {
          const { session, turn } = this.getSessionFromAbsoluteTurn(absoluteTurnNumber);
          return `<span style="font-size: 10px !important;">
            ${sessionLabel}: ${session}
            <br>
            ${turnLabel}: ${turn}
          </span>`;
        }
        return `<span>${startLabel}</span>`;
      },
      onFinish: (event) => {
        const absoluteTurnNumber = event.from;
        const { session, turn } = this.getSessionFromAbsoluteTurn(absoluteTurnNumber);
        this.dataSource.refreshData({ filters: { ...this.dataSource.filters, session, turn } });
      }
    };
  }

  onDatasourceUpdate() {
    StoreService.update(this.listId, this.dataSource);
  }

  private getCurrentSessionIndex() {
    return this.group.sessions.reduce(
      (sessionIndex, { startDate }) => (Date.now() >= new Date(startDate).getTime() ? sessionIndex + 1 : sessionIndex),
      0
    );
  }

  private getSessionFromAbsoluteTurn(absoluteTurnNumber: number) {
    const { maxTurns } = this.group;
    return {
      session: Math.ceil(absoluteTurnNumber / maxTurns),
      turn: absoluteTurnNumber
    };
  }
}
